/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';

import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';
import { usePolicyId } from '../../provider';
import { apiConfig } from '@pages/ProvisionalDetailPage/config/api.config';
import { CANCEL_POLICY } from '@pages/ProvisionalDetailPage/api/graphql';

export interface ICancelPolicyStatusPluginMethods extends IPluginMethodMap {
  getCancelPolicyStatus(args?: any): Promise<any>;
}

export class CancelPolicyStatusPlugin implements IAgentPlugin {
  readonly methods: ICancelPolicyStatusPluginMethods;

  constructor() {
    this.methods = {
      getCancelPolicyStatus: this.getCancelPolicyStatus.bind(this),
    };
  }

  async getCancelPolicyStatus(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));
    await this.findCapsules();
    return {
      //products: this.formatProducts(this.products),
    };
  }
  //Graphql Query example
  async findCapsules(args?: any) {
    let gql = Graphql.withBaseUrl(apiConfig.spacex_gql.url);
    // const token = getToken();
    const token = null;
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    const { policyNumber } = usePolicyId();
    try {
      const res = await client
        .mutation(CANCEL_POLICY, {
          policyId: policyNumber,
          reason: args?.comments,
        })
        .toPromise();
      if (res?.data?.cancelPolicy) {
        return res?.data?.cancelPolicy;
      }
      //log.log('result of capsules=', res?.data?.capsules);
    } catch (err: any) {
      log.error('error in capsules=', err?.message);
      throw err;
    }
  }

  // private formatProducts(products: any) {
  //   return products.map((product: any) => product);
  // }
}
